<template>
  <div class="tab-content hide-scrollbar" ref="tabPanelsRef" :key="modelValue">
    <slot />
  </div>
</template>
  
<script>
import { reactive, toRefs, onUpdated, watch } from "vue";

export default {
  name: "TabContent",
  props: {
    modelValue: {
      default: '',
      type: String,
    },
  },
  setup(props) {
    const state = reactive({
      tabPanelsRef: null,
      start: false,
      startPosition: {
        x: 0,
        y: 0,
      },
      tabPanelOptions: [],
      currentModelValue: 'talk',
      previousModalPostionTop: {
        talk: 0,
        bookmark: 0,
      },
    });

    onUpdated(() => {
      scrollToModelValue(props.modelValue);
    });

    watch(() => props.modelValue, async (modelValue, previousModelValue) => {
      const chatPanel = document.querySelector('#chat-panel');
      state.previousModelValue = previousModelValue;
      const previousPositionTop = chatPanel ? chatPanel.scrollTop : 0;
      previousModelValue == 'bookmark' ? state.previousModalPostionTop.bookmark = previousPositionTop :
      state.previousModalPostionTop.talk = previousPositionTop;
      await scrollToModelValue(modelValue);
      state.currentModelValue = modelValue;
    }, { immediate: true });

    function scrollToModelValue(modelValue) {
      const chatPanel = document.querySelector('#chat-panel');
      if (!state.previousModelValue && chatPanel) {
        state.previousModalPostionTop.bookmark = chatPanel.scrollHeight;
        state.previousModalPostionTop.talk = chatPanel.scrollHeight;
      }
      const top = props.modelValue === 'bookmark' ? state.previousModalPostionTop.bookmark : state.previousModalPostionTop.talk;
      if (modelValue != state.currentModelValue && chatPanel) {
        chatPanel.scrollTo({ top: top, left: 0 });
      }
    }
    return {
      ...toRefs(state),
    };
  },
};
</script>
  
<style scoped>
.tab-content {
  white-space: nowrap;
  overflow: hidden;
}
.hide-scrollbar::-webkit-scrollbar {
  display: none;
}
.hide-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>
